import Phaser from 'phaser';
import './styles.css';
import { GAME, BRAND, RENDER_SCALE } from './config';
import { BootScene } from './scenes/BootScene';
import { MenuScene } from './scenes/MenuScene';
import { BriefingScene } from './scenes/BriefingScene';
import { LevelScene } from './scenes/LevelScene';
import { ResultScene } from './scenes/ResultScene';

// Render every Text object at the supersampled resolution so it stays sharp
// when the scene camera magnifies the logical layout (see src/hidpi.ts).
const baseTextFactory = Phaser.GameObjects.GameObjectFactory.prototype.text;
Phaser.GameObjects.GameObjectFactory.prototype.text = function (x, y, text, style) {
  return baseTextFactory.call(this, x, y, text, style).setResolution(RENDER_SCALE);
};

new Phaser.Game({
  type: Phaser.AUTO,
  parent: 'game-frame',
  width: GAME.width * RENDER_SCALE,
  height: GAME.height * RENDER_SCALE,
  backgroundColor: BRAND.ink,
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
  input: {
    // Don't swallow page wheel events — let the browser scroll if the
    // canvas overflows the viewport.
    mouse: { preventDefaultWheel: false },
  },
  scene: [BootScene, MenuScene, BriefingScene, LevelScene, ResultScene],
});
